module.exports = __webpack_public_path__ + "img/abt-2.62af1630.png";